import { React, useState } from 'react'

//Funciones comunes
import { useLanguage } from './../../../utilities/LanguageContext'
import { LogErrors } from './../../../utilities/LogErrors'

import { ChangeTheme as BLChangeTheme, ChangeFontSize as BLChangeFontSize } from './../../../utilities/BL/Settings'


const SignUpHeader = ({ setTheme }) => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto

    const [theTheme, setTheTheme] = useState(null)


    const ChangeTheme = async (idThemeToSave) => {
        try {
            const response = await BLChangeTheme(idThemeToSave)

            if (response.success) {
                setTheTheme(response.data)
                setTheme(response.data)
            } else {
                console.log(response.message)
            }
        } catch (error) {
            await LogErrors('ChangeTheme - SignUpHeader', error)
        }
    }

    const ChangeFontSize = async (idFontSizeToSave) => {
        try {
            const response = await BLChangeFontSize(idFontSizeToSave)

            if (!response.success) {
                console.log(response.message)
            }
        } catch (error) {
            await LogErrors('ChangeFontSize - SignUpHeader', error)
        }
    }


    return (
        <div className='container EvaluatorHeader'>
            <div className='EvaluatorHeader-SignUp'></div>

            <div className='EvaluatorHeader-Settings Header'>
                <div className="btn-group Header__Menu">
                    <button type="button" className="dropdown-toggle Header__Menu__Button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="bi bi-gear"></i>
                    </button>
                    
                    <ul className="dropdown-menu dropdown-menu-end">
                        <li>
                            {theTheme && theTheme === 2 ? (
                                <button className="dropdown-item" type="button" onClick={() => ChangeTheme(1)}>
                                    <i className="bi bi-sun"></i> {translate('labels.header.themes.light')}
                                </button>
                            ) : (
                                <button className="dropdown-item" type="button" onClick={() => ChangeTheme(2)}>
                                    <i className="bi bi-moon"></i> {translate('labels.header.themes.dark')}
                                </button>
                            )}
                        </li>
                        <li className="dropdown-item EvaluatorHeader-Size"> {/* Ajustar clases */}
                            <span className="EvaluatorHeader-Size-Small" onClick={() => ChangeFontSize(0)}>A</span>
                            <span className="EvaluatorHeader-Size-Medium" onClick={() => ChangeFontSize(1)}>A</span>
                            <span className="EvaluatorHeader-Size-Big" onClick={() => ChangeFontSize(2)}>A</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export { SignUpHeader };